export interface AccessTokenPayload {
  userId: string;
  roleId?: number;
  role?: string;
}

// Reads the claims out of a JWT without verifying the signature — that's the
// backend's job. The token is short-lived and always sent to the API on every
// request, so a client just trusting its own claims for UI purposes is safe.
export const decodeAccessToken = (token: string): AccessTokenPayload | null => {
  try {
    const payloadSegment = token.split('.')[1];
    const base64 = payloadSegment.replace(/-/g, '+').replace(/_/g, '/');
    const json = decodeURIComponent(
      atob(base64)
        .split('')
        .map((c) => '%' + c.charCodeAt(0).toString(16).padStart(2, '0'))
        .join(''),
    );

    return JSON.parse(json);
  } catch {
    return null;
  }
};
